import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../side-bar.component";
import { toast, ToastContainer } from "react-toastify";

import { NavLink, Outlet } from "react-router-dom";
import HeaderComponent from "../../header/header.component";
import SidebarMenu from "../../sidebar-menu/sidebar-menu.component";
import { useEffect, useState } from "react";
import { GetPermission } from "../../../apis/pvlapis";
import PermissionDenied from "../../shared/permission-denied.component";
import LoadingAnimation from "../lottie-files/loading.lotte";

const BillingComponent = () => {
  const [isPermissionLoading, setIsPermissionLoading] = useState(false);
  const [showBillingTab, setShowBillingTab] = useState(null);

  useEffect(() => {
    handleGetPermission();
  }, []);

  const handleGetPermission = async () => {
    setIsPermissionLoading(true);

    try {
      const response = await GetPermission();
      if (response.statusCode !== 200 || response?.result === null) {
        return;
      }
      const subscriptionView = response?.result?.find(
        (obj) => obj?.component === "settingsviewsubscription"
      );

      setShowBillingTab(subscriptionView?.permission);
    } catch (error) {
      toast.error("Something went wrong. Please try again after some time.", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } finally {
      setIsPermissionLoading(false);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-auto sidebar-menu sticky-top">
            <SidebarMenu />
          </div>
          <div className="col-sm min-vh-100 p-0">
            <div>
              <HeaderComponent />
              <Container fluid className="main-page-wrap">
                <Row>
                  <Col>
                    <div className="d-flex align-items-center justify-content-between page-header py-3">
                      <span className="font-18 dark-text poppins-semibold">
                        Settings
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col sm={3}>
                    <Sidebar />
                  </Col>
                  {showBillingTab && !isPermissionLoading && (
                    <Col sm={9}>
                      <div className="profile-card">
                        <div className="card-title">Billing</div>
                        <div
                          id="integration-nav-tabs"
                          className="justify-content-start gap-40 my-2 minus-left-right-24"
                        >
                          <NavLink
                            to="subscription"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <div>Subscription</div>
                          </NavLink>
                          <NavLink
                            to="cards"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <div> Credit Cards</div>
                          </NavLink>
                        </div>
                        <Outlet />
                      </div>
                    </Col>
                  )}
                  {!showBillingTab && !isPermissionLoading && (
                    <Col sm={9}>
                      <div className="profile-card mb-4">
                        <PermissionDenied />
                      </div>
                    </Col>
                  )}
                  {isPermissionLoading && (
                    <div className="loading-animation">
                      <LoadingAnimation />
                      <span>Loading data, please wait...</span>
                    </div>
                  )}
                </Row>
                <ToastContainer />
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingComponent;
